module.exports = __webpack_public_path__ + "media/images/vector-36@2x-02834ff91e7afe5e1eab7a9c01776c2d.png";